export enum TransactionStatus {
    Approved = 'approved',
    Pending = 'pending',
    Declined = 'declined',
}

export enum TransactionType {
    TransferCredit = 'transfer_credit',
    SendCredit = 'send_credit',
    TransferDebit = 'transfer_debit',
    SendDebit = 'send_debit',
    WithdrawSepa = 'withdraw_sepa',
    Deposit = 'deposit',
    Withdraw = 'withdraw',
    ClearingFee = 'clearing_fee',
    ClearingDebit = 'clearing_debit',
    BankFee = 'bank_fee',
    DepositSepa = 'deposit_sepa',
    WithdrawSepaCancel = 'withdraw_sepa_cancel',

    AccountAdjustment = "AccountAdjustment",
    Authorization = "Authorization",
    Fee = "Fee",
}

export enum TransactionFilters {
    IN = 'IN',
    OUT = 'OUT',
    PENDING = 'PENDING',
    HOLD = 'HOLD',
    QUERY = 'QUERY',
}

export type Transaction = {
    amount: number;
    created: string;
    currency: string;
    description: string;
    details: string;
    holdStatus: string | null;
    iban: string | null;
    id: string;
    recipientName: string;
    status: TransactionStatus;
    type: TransactionType;
    mcc: string | null;
    merchantId: string | null;
    terminalId: string | null;
    merchantCity: string | null;
    merchantCountryCode: string | null;
    accountId?: number;
};

export type Transactions = Transaction[];

export type TransactionDetails = {
    account?: {
        balance: {
            available: number;
            hold: number;
            total: number;
        };
        client: {
            created: string;
            currency: string;
            iban: string;
            id: string;
            title: string;
            type: string;
        };
        iban: string;
        title: string;
        type: string;
    };
    amount: number;
    card?: {
        account_id: number;
        cardholder: string;
        client_id: number;
        id: number;
        number_masked: string;
        status: TransactionType;
        type: string;
    };
    client?: {
        created: string;
        currency: string;
        iban: string;
        id: string;
        title: string;
        type: string;
    };
    created: string;
    currency: string;
    description?: string;
    details?: {
        description: string;
    };
    document?: {
        account_id: number;
        amount: number;
        corr_account_id: string;
        created: string;
        currency: string;
        description: string;
        extra: {
            fee_amount: string;
            iban: string;
            note: string;
        };
        id: string;
        recipient_name: string;
        sender_name: string;
        status: TransactionStatus;
        type: string;
    };
    id: number;
    online_message?: {
        amount: number;
        descriptor: string;
        id: number;
        status: string;
        type: string;
    };
    origin_created?: string;
    type?: TransactionType;
    status?: TransactionStatus;
};

export type HoldDetails = {
    authorizationTransaction: TransactionDetails;
    holdTransaction?: TransactionDetails;
};
